import Class from './c-chart-bars-view';
import './c-chart-bars-view@';

export default Class;